import React from "react";
import { Div, Text, Image, Collapse, Icon } from "atomize";
import CustomContainer from "../common/CustomContainer";
import WebsiteContainer from "../common/WebsiteContainer";

class CollapseStucture extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showCollapse: false,
    };
  }

  toggleCollapse = value => {
    const { showCollapse } = this.state;

    if (showCollapse === value) {
      this.setState({ showCollapse: false });
    } else {
      this.setState({ showCollapse: value });
    }
  };

  render() {
    const { items, title } = this.props;
    const { showCollapse } = this.state;

    return (
      <>
        <WebsiteContainer>
          <CustomContainer>
            <Div
              textSize={{ xs: "caption4", md: "subheader3" }}
              border={{
                b: "1px solid",
              }}
              borderColor="border"
              p={{
                t: { xs: "6rem", md: "9rem" },
                b: { xs: "1.5rem", md: "3rem" },
              }}
              textWeight="600"
              textAlign={{ xs: "center", md: "left" }}
              tag="h2"
            >
              {title}
            </Div>
            {items.map((item, index) => (
              <Div
                border={{
                  b: "1px solid",
                }}
                borderColor="border"
                onClick={() => this.toggleCollapse(index)}
                cursor="pointer"
                key={item.id}
              >
                <Div
                  d="flex"
                  justify="space-between"
                  p={{ xs: "1rem 0rem", md: "2.5rem 2rem" }}
                >
                  <Text
                    textColor="white"
                    textSize={{ xs: "paragraph", md: "subheader2" }}
                    textWeight="600"
                  >
                    {item.question.question}
                  </Text>
                  <Div
                    h="20px"
                    w="20px"
                    transform={`rotate(${
                      showCollapse === index ? "90" : "0"
                    }deg)`}
                    transition="all 0.2s ease-in-out"
                  >
                    <Icon name="RightArrow" size="20px" color="white" />
                  </Div>
                </Div>
                <Collapse isOpen={showCollapse === index}>
                  <Div
                    p={{ xs: "0 0 1rem", md: "0 2.5rem 2.7rem" }}
                    textColor="gray700"
                    w="100%"
                    textSize={{ xs: "paragraph", md: "subheader2" }}
                  >
                    {item.answer.answer}
                  </Div>
                </Collapse>
              </Div>
            ))}
          </CustomContainer>
        </WebsiteContainer>
      </>
    );
  }
}

export default CollapseStucture;
